<template>
  <div id="systemUpdatesList_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            檢視系統公告
          </div>
        </div>
      </div>
      <el-form
        label-position="right"
        label-width="80px"
      >
        <el-form-item label="標題">
          <el-tag
            v-if="data.IsNew"
            type="danger"
          >
            New
          </el-tag>
          <span v-if="data.Title != ''">{{ data.Title }}</span>
          <span v-else>無</span>
        </el-form-item>
        <el-form-item label="發佈日期">
          <p>{{ data.CreateDate }}</p>
        </el-form-item>
        <el-form-item label="內容">
          <div
            ref="content"
            class="content"
          />
        </el-form-item>
      </el-form>
      <div class="bottomControl">
        <el-button
          round
          @click="$router.push({name:'SystemUpdates'})"
        >
          返回系統公告列表
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      data: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      const requestData = {
        id: this.$route.params.id
      }
      apiSystem.GetSystemDetail(
        requestData
      ).then((res) => {
        if (res.data.Status === 1) {
          res.data.Data.CreateDate = (res.data.Data.CreateDate != null) ? res.data.Data.CreateDate.slice(0, 16) : ''
          this.data = res.data.Data
          this.$nextTick(function () {
            this.$refs.content.innerHTML = res.data.Data.Content
          })
        } else {
          console.log('錯誤，res.data.Status' + res.data.Status)
        }
        this.loading = false
      }).catch((err) => {
        if (err.response !== undefined) {
          console.log('錯誤訊息：', err.response)
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
#systemUpdatesList_main
  +mainLayer
  max-width: 1140px
  margin: 0 auto
  .el-form
    text-align: left
    padding-left: 30px
    ::v-deep .el-form-item__label
      font-size: 15px
      font-weight: bold
      color: $mainFontColor
      margin-right: 20px
      line-height: 40px
    .el-tag
      margin-right: 20px
      font-weight: bold
    ::v-deep .el-form-item__content
      border: 0
      .content
        word-break: break-word
        ol, ul, li
          list-style: revert
          padding: revert
          margin: revert
        html, body, div, span, applet, object, iframe,h1, h2, h3, h4, h5, h6, p, blockquote, pre,a, abbr, acronym, address, big, cite, code,del, dfn, em, img, ins, kbd, q, s, samp,small, strike, strong, sub, sup, tt, var,b, u, i, center,dl, dt, dd,fieldset, form, label, legend,table, caption, tbody, tfoot, thead, tr, th, td,article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary,time, mark, audio, video
          margin: revert
          padding: revert
          font: revert
          font-size: revert
          vertical-align: revert
  .bottomControl
    border-top: solid 1px $borderDark1
    padding-top: 30px
</style>
